import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import VGRollup from "./modules/VGRollup";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.fixedHeader($(window));
		VG.scrollToSection();
		VG.clone();

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
};

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	clone: () => {
		const cloned = () => {
			const whom = document.querySelector('.orginfos-categories--clone');
			const to = document.querySelector('.orginfos-sidebar--clone-categories');
			if (!whom || !to) return;

			to.textContent = '';
			const clone = whom.cloneNode(true);
			to.append(clone);
		};

		if (window.innerWidth <= 1199) {
			cloned();
		}

		window.onresize = () => {
			if (window.innerWidth <= 1199) {
				cloned();
			}
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function () {
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableVGRollup();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>'
			});
		},

		enableVGRollup: function () {
			let rollups = document.querySelectorAll('[data-rollup-content]');
			for (let i = 1; i <= rollups.length; i++) {
				let target = rollups[i - 1].getAttribute('id');
				new VGRollup(target);

				let $target = document.querySelector(`#${target}`);

				if($target.closest('.swiper')) {
					let id = $target.closest('.swiper').getAttribute('id');

					$target.addEventListener('rollup-show', () => {
						const swiper = document.querySelector(`#${id}`);
						swiper.swiper.updateAutoHeight(300);
					});
					$target.addEventListener('rollup-hide', () => {
						const swiper = document.querySelector(`#${id}`);
						swiper.swiper.updateAutoHeight(300);
					})
				}
			}
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function () {
			// $('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			$offset = 0,
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > $offset) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}
	},

	scrollToSection: () => {
		const link = document.querySelectorAll('[data-scroll-to-section]');
		const hash = window.location.hash;

		const scroller = (section) => {
			scrollTo({
				behavior: "smooth",
				top: section.offsetTop + 75
			})
		};

		if(hash) {
			let section = document.querySelector(hash);
			console.log(hash, section);
			setTimeout(function () {
				scroller(section);
			}, 300);
		}

		[...link]
			.forEach(el => {
				el.onclick = (e) => {
					e.preventDefault();
					let path = el.href;
					let id = path.slice(path.indexOf('#'));

					let section = document.querySelector(id);
					console.log(id, section)

					if (!section) {
						console.log('а к чему скролить то ???');
						return
					}

					scroller(section)
				}
			})
	},
};

export default VGListener;
